module.exports = __webpack_public_path__ + "static/media/wallets_restantes.f4f15004.svg";